import React from "react";
import { Box } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import ProduksiDashboard from "../components/ProduksiDashboard";

const DashboardProduksi = () => {
    return (
        <Box h="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box flex="1" zIndex={1}>
                <ProduksiDashboard />
            </Box>
        </Box>
    );
};

export default DashboardProduksi;